// src/components/common/AnimatedBackground.js
import React from 'react'
import { Box } from '@mui/material'

const NAV_HEIGHT = 76

const AnimatedBackground = () => {
    return (
        <Box
            aria-hidden="true"
            sx={{
                position: 'absolute',
                top: `${NAV_HEIGHT}px`,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 0,
                pointerEvents: 'none',
                background: `
                    radial-gradient(circle at 20% 30%, rgba(109,60,255,0.2), transparent 40%),
                    radial-gradient(circle at 80% 70%, rgba(255,138,0,0.15), transparent 40%),
                    #0B0620
                `,
            }}
        />
    )
}

export default AnimatedBackground